/**
 * Platform and Device Detection Utility
 * Detects platform, device type, and browser from user agent string
 */

export const detectPlatform = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  
  // Platform detection
  let platform = 'unknown';
  let device = 'unknown';
  let browser = 'unknown';
  
  // Mobile detection
  if (/android/.test(userAgent)) {
    platform = 'android';
    device = 'mobile';
  } else if (/iphone|ipad|ipod/.test(userAgent)) {
    platform = 'ios';
    if (/ipad/.test(userAgent)) {
      device = 'tablet';
    } else {
      device = 'mobile';
    }
  } else if (/windows phone/.test(userAgent)) {
    platform = 'windows-phone';
    device = 'mobile';
  } else if (/blackberry/.test(userAgent)) {
    platform = 'blackberry';
    device = 'mobile';
  } else if (/windows/.test(userAgent)) {
    platform = 'windows';
    device = 'desktop';
  } else if (/macintosh|mac os x/.test(userAgent)) {
    platform = 'macos';
    device = 'desktop';
  } else if (/linux/.test(userAgent)) {
    platform = 'linux';
    device = 'desktop';
  } else if (/chrome os/.test(userAgent)) {
    platform = 'chromeos';
    device = 'desktop';
  }
  
  // Browser detection
  if (/chrome/.test(userAgent) && !/edge/.test(userAgent)) {
    browser = 'chrome';
  } else if (/firefox/.test(userAgent)) {
    browser = 'firefox';
  } else if (/safari/.test(userAgent) && !/chrome/.test(userAgent)) {
    browser = 'safari';
  } else if (/edge/.test(userAgent)) {
    browser = 'edge';
  } else if (/opera/.test(userAgent)) {
    browser = 'opera';
  } else if (/msie|trident/.test(userAgent)) {
    browser = 'ie';
  }
  
  // Additional device detection for tablets
  if (device === 'desktop' && /tablet|ipad/.test(userAgent)) {
    device = 'tablet';
  }
  
  // PWA detection
  const isPWA = window.matchMedia('(display-mode: standalone)').matches || 
                window.navigator.standalone === true;
  
  return {
    platform,
    device,
    browser,
    userAgent: navigator.userAgent,
    isPWA,
    isMobile: device === 'mobile',
    isTablet: device === 'tablet',
    isDesktop: device === 'desktop'
  };
};

/**
 * Get a simplified platform string for API calls
 */
export const getPlatformString = () => {
  const { platform, device } = detectPlatform();
  return `${platform}-${device}`;
};

/**
 * Get a detailed platform string for API calls
 */
export const getDetailedPlatformString = () => {
  const { platform, device, browser, isPWA } = detectPlatform();
  let result = `${platform}-${device}-${browser}`;
  if (isPWA) {
    result += '-pwa';
  }
  return result;
};

/**
 * Get device info for FCM token registration
 */
export const getDeviceInfo = () => {
  const detection = detectPlatform();
  return {
    platform: detection.platform,
    device: detection.device,
    browser: detection.browser,
    isPWA: detection.isPWA,
    userAgent: detection.userAgent
  };
};

export default detectPlatform;
